module.exports = __webpack_public_path__ + "public/Icons/edit.png?a76f7d93";